import React from 'react';
import Tabs from '@solar/common/Tabs/Tabs';
import TextLink from '@solar/common/Link/TextLink';
import Heading from '@solar/common/Heading/Heading';
import hotelDayPassesByLocation from '@constants/hotelDayPassesBylocation';
import Paragraph from '@solar/common/Paragraph/Paragraph';
import Link from 'next/link';

export default function StaticDayPassesByLocation() {
  return (
    <div
      className="flex flex-col space-y-spacing-lg w-full desktop:max-w-1090px desktop:mx-auto"
      data-testid="day-passes-by-location-section"
    >
      <Heading level={3} className="px-spacing-md w-full desktop:px-spacing-none">
        Hotel Day Passes by City
      </Heading>

      <div className="pl-spacing-md flex flex-col overflow-x-auto w-full desktop:overflow-x-hidden desktop:pl-0">
        <div className="min-w-900px pr-4 desktop:min-w-0 desktop:pr-0">
          <Tabs defaultValue={hotelDayPassesByLocation[0].title} onSelect={() => {}} size="md">
            <Tabs.List alignment="left">
              {hotelDayPassesByLocation.map((location) => (
                <Tabs.Tab key={location.title} value={location.title}>
                  {location.title}
                </Tabs.Tab>
              ))}
            </Tabs.List>

            <Tabs.Panels className="flex flex-col mt-spacing-xl">
              {hotelDayPassesByLocation.map((location, index) => (
                <Tabs.Panel value={location.title} key={location.title}>
                  <div className="flex flex-col pb-5 space-y-spacing-lg">
                    <div className="grid grid-cols-5 grid-rows-5 gap-x-spacing-md gap-y-spacing-lg desktop:gap-x-spacing-lg">
                      {location.data.map((item) => (
                        <div key={item.name} className="w-41.25 desktop:w-50">
                          <TextLink
                            key={item.name}
                            href={item.url}
                            title={item.name}
                            className="truncate"
                          >
                            {item.name}
                          </TextLink>

                          {index === 0 && (
                            <Link href={item.url} title={`${item.name} Hotel day passes`}>
                              <a>
                                <Paragraph size="sm" className="text-solar-secondary">
                                  Hotel day passes
                                </Paragraph>
                              </a>
                            </Link>
                          )}
                        </div>
                      ))}
                    </div>

                    <div className="flex">
                      <TextLink title="View All" href={location.allUrl}>
                        View All
                      </TextLink>
                    </div>
                  </div>
                </Tabs.Panel>
              ))}
            </Tabs.Panels>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
